export const WalletCheckIcon = ({ size = 16, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M2 5.33333V10.6667C2 12 2.66667 13.3333 4.66667 13.3333H11.3333C13.3333 13.3333 14 12 14 10.6667V5.33333C14 4 13.3333 2.66667 11.3333 2.66667H4.66667C2.66667 2.66667 2 4 2 5.33333Z"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2 5.33333H14"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
